import React, { useState } from 'react';
import { 
  Users, Zap, CheckCircle2, Search, Smartphone, 
  Database, ShieldCheck, ArrowUpCircle, History, 
  UserPlus, DollarSign, Filter, RefreshCcw
} from 'lucide-react';

/**
 * 🛰️ SAHELGUARD AGENT COMMAND CENTER - V12.0
 * ---------------------------------------------------
 * Architecture : Moussa Yarbanga | Yarmotek Sovereign Cloud
 * Rôle : Validation des paiements, Upgrades et Scellage Client.
 * Logic : Gestion des paliers de 32 Go à 1024 Go (Forteresse).
 */

const AgentCommandCenter = ({ apiUrl }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [isUpdating, setIsUpdating] = useState(false);

  // --- GRILLE TARIFAIRE OFFICIELLE SAHELGUARD 2026 ---
  const gradeQuotas = {
    'SENTINELLE': 32,
    'PIVOT': 64,
    'REMPART': 128,
    'BOUCLIER': 256,
    'CITADELLE': 512,
    'FORTERESSE': 1024
  };

  // Exemple de client en attente d'upgrade (Simulation flux WhatsApp)
  const [mockClient, setMockClient] = useState({
    token: 'SG-BFA-7701',
    name: 'Ibrahim Diallo',
    currentPlan: 'SENTINELLE',
    currentQuota: 32,
    saturation: 84, // Indicateur d'urgence pour l'agent
    phone: '+22670000000'
  });

  const handleUpgradeValidation = async (newGrade) => {
    const confirmMsg = `CONFIRMATION SOUVERAINE :\n\nClient : ${mockClient.name}\nNouveau Grade : ${newGrade}\nQuota : ${gradeQuotas[newGrade]} Go\n\nConfirmer l'encaissement et le scellage ?`;
    
    if (!window.confirm(confirmMsg)) return;
    
    setIsUpdating(true);
    try {
      // 📡 APPEL API D1 VIA LE WORKER
      // const response = await fetch(`${apiUrl}/api/agent/upgrade`, {
      //   method: 'POST',
      //   body: JSON.stringify({ token: mockClient.token, grade: newGrade })
      // });
      
      // Simulation du délai de scellage D1
      setTimeout(() => {
        setMockClient(prev => ({
          ...prev,
          currentPlan: newGrade,
          currentQuota: gradeQuotas[newGrade],
          saturation: Math.floor((prev.currentQuota / gradeQuotas[newGrade]) * prev.saturation)
        }));
        setIsUpdating(false);
        alert(`SCELLAGE RÉUSSI : Le terminal ${mockClient.token} est désormais sous protection ${newGrade}.`);
      }, 1500);
    } catch (e) {
      setIsUpdating(false);
      alert("ERREUR CRITIQUE : Échec de communication avec le Core D1.");
    }
  };

  return (
    <div className="min-h-screen bg-[#050505] text-white p-6 font-sans selection:bg-emerald-500/30">
      
      {/* 🏛️ HEADER AGENT & COMMISSIONS */}
      <header className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6 mb-12 border-b border-white/5 pb-8">
        <div>
          <h1 className="text-2xl font-black italic uppercase tracking-tighter flex items-center gap-2">
            SahelGuard <span className="bg-emerald-500 text-black px-2 py-0.5 text-[10px] not-italic rounded">AGENT PORT</span>
          </h1>
          <p className="text-[10px] font-bold text-slate-500 uppercase tracking-[0.3em] mt-1">
            Opérateur : Yarmotek Central (ID: AG-CENTRAL-01)
          </p>
        </div>
        
        <div className="flex gap-4 w-full md:w-auto">
          <div className="flex-1 md:flex-none bg-white/5 p-4 rounded-2xl border border-white/10 min-w-[160px]">
            <p className="text-[8px] font-black text-slate-500 uppercase italic mb-1">Commission Gérée</p>
            <p className="text-xl font-black text-emerald-500">145.500 <span className="text-[10px] text-white/50">FCFA</span></p>
          </div>
          <button className="flex-1 md:flex-none bg-emerald-500 text-black px-8 rounded-2xl font-black uppercase text-[10px] flex items-center justify-center gap-2 hover:bg-white hover:scale-105 transition-all active:scale-95">
            <UserPlus size={18} /> Nouveau Scellage
          </button>
        </div>
      </header>

      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-8">
        
        {/* 🔍 COLONNE GAUCHE : FLUX DE DEMANDES (WHATSAPP/SMS) */}
        <div className="lg:col-span-4 space-y-6">
          <div className="relative group">
            <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-500 group-focus-within:text-emerald-500 transition-colors" size={18} />
            <input 
              type="text" 
              placeholder="Rechercher ID ou N° Client..." 
              className="w-full bg-white/5 border border-white/10 rounded-2xl p-5 pl-12 font-mono text-sm outline-none focus:border-emerald-500/50 focus:bg-white/[0.08] transition-all uppercase"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>

          <div className="bg-white/[0.02] border border-white/10 rounded-[2rem] overflow-hidden backdrop-blur-md">
             <div className="p-6 border-b border-white/5 bg-white/[0.01] flex justify-between items-center">
                <h3 className="text-xs font-black uppercase tracking-widest text-slate-400">Demandes en attente</h3>
                <span className="bg-red-500 text-white text-[8px] font-black px-2 py-0.5 rounded-full">3 LIVE</span>
             </div>
             <div className="divide-y divide-white/5">
                {/* Client Actif Simulation */}
                <div className="p-6 bg-emerald-500/10 flex justify-between items-center border-l-4 border-emerald-500 cursor-pointer">
                    <div>
                        <p className="text-xs font-black uppercase tracking-wider">{mockClient.token}</p>
                        <p className="text-[10px] text-slate-400 font-bold">{mockClient.name}</p>
                    </div>
                    <div className="text-right">
                        <p className="text-[9px] font-black text-emerald-500 uppercase italic">Prêt pour Upgrade</p>
                        <p className="text-[8px] text-slate-500">Source : App Mobile</p>
                    </div>
                </div>
                
                {/* Historique/Autres */}
                {['SG-BFA-0921', 'SG-BFA-1102'].map(id => (
                    <div key={id} className="p-6 flex justify-between items-center opacity-40 hover:opacity-100 transition-opacity cursor-not-allowed">
                        <p className="text-xs font-black uppercase">{id}</p>
                        <span className="text-[8px] font-black uppercase bg-white/5 px-2 py-1 rounded">Vérification KYC...</span>
                    </div>
                ))}
             </div>
          </div>
        </div>

        {/* ⚡ COLONNE DROITE : CONSOLE DE SCELLAGE & UPGRADE */}
        <div className="lg:col-span-8 space-y-8">
          <div className="bg-white/[0.02] border border-white/10 rounded-[3rem] p-8 md:p-12 relative overflow-hidden backdrop-blur-xl">
            
            {/* Infos Client Focus */}
            <div className="flex flex-col md:flex-row justify-between items-start gap-8 mb-16 relative z-10">
              <div className="space-y-2">
                <div className="flex items-center gap-3">
                  <span className="bg-emerald-500 text-black text-[9px] font-black px-3 py-1 rounded-full uppercase italic tracking-tighter">SÉLECTION AGENT</span>
                  <span className="text-[10px] font-mono text-slate-500 tracking-widest">{mockClient.token}</span>
                </div>
                <h2 className="text-5xl font-black italic uppercase tracking-tighter text-transparent bg-clip-text bg-gradient-to-r from-white to-slate-500">
                  {mockClient.name}
                </h2>
                <div className="flex items-center gap-4">
                  <p className="text-xs font-bold text-slate-400 uppercase italic tracking-widest">{mockClient.phone}</p>
                  <span className="h-1 w-1 bg-slate-700 rounded-full"></span>
                  <p className="text-[10px] font-black text-emerald-500 uppercase">Compte Certifié KYC</p>
                </div>
              </div>

              <div className="p-6 bg-black/50 rounded-3xl border border-white/10 text-center min-w-[140px] backdrop-blur-md">
                <p className="text-[8px] font-black text-slate-500 uppercase mb-2 tracking-[0.2em]">Protection Actuelle</p>
                <p className="text-2xl font-black text-white leading-none">{mockClient.currentPlan}</p>
                <div className="mt-2 h-1.5 w-full bg-white/5 rounded-full overflow-hidden">
                   <div className="h-full bg-emerald-500" style={{ width: `${mockClient.saturation}%` }}></div>
                </div>
                <p className="text-[9px] font-bold text-slate-500 mt-2">{mockClient.currentQuota} Go Scellés</p>
              </div>
            </div>

            {/* Sélecteur de Grade (Actions Agent) */}
            <div className="space-y-6 relative z-10">
               <div className="flex items-center gap-4 mb-8">
                  <div className="h-px flex-1 bg-white/10"></div>
                  <h3 className="text-[10px] font-black uppercase tracking-[0.4em] text-slate-500">Protocoles de Mise à Niveau</h3>
                  <div className="h-px flex-1 bg-white/10"></div>
               </div>

               <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
                  {Object.entries(gradeQuotas).map(([grade, quota]) => {
                    const isCurrent = mockClient.currentPlan === grade;
                    const isLower = quota < mockClient.currentQuota;
                    
                    return (
                      <button 
                        key={grade}
                        disabled={isCurrent || isLower || isUpdating}
                        onClick={() => handleUpgradeValidation(grade)}
                        className={`group relative p-6 rounded-3xl border text-left transition-all duration-300 ${
                          isCurrent 
                          ? 'bg-emerald-500 border-emerald-500 text-black shadow-lg shadow-emerald-500/20' 
                          : isLower ? 'opacity-20 border-white/5 grayscale cursor-not-allowed'
                          : 'bg-white/5 border-white/10 hover:border-emerald-500/50 hover:bg-white/[0.08]'
                        }`}
                      >
                        <div className="flex justify-between items-start mb-4">
                           <ArrowUpCircle className={isCurrent ? 'text-black' : 'text-slate-600 group-hover:text-emerald-500'} size={24} />
                           {isCurrent && <CheckCircle2 size={16} />}
                        </div>
                        <span className="block text-xs font-black uppercase tracking-tighter">{grade}</span>
                        <span className={`block text-[9px] font-bold uppercase ${isCurrent ? 'text-black/60' : 'text-slate-500'}`}>
                           {quota} Go Unités
                        </span>
                      </button>
                    );
                  })}
               </div>
            </div>

            {/* Validation & Encaissement */}
            <div className="mt-16 pt-10 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-8 relative z-10">
                <div className="flex items-center gap-4">
                    <div className="p-3 bg-white/5 rounded-xl text-slate-500"><History size={20} /></div>
                    <div>
                      <p className="text-[8px] font-black text-slate-500 uppercase tracking-widest">Dernière Opération</p>
                      <p className="text-[10px] font-bold text-white uppercase">Scellage Initial - 18/03/2026</p>
                    </div>
                </div>
                
                <div className="flex gap-4 w-full md:w-auto">
                  <button className="flex-1 md:flex-none px-8 py-5 bg-white/5 rounded-2xl text-[10px] font-black uppercase hover:bg-red-500/10 hover:text-red-500 transition-all border border-transparent hover:border-red-500/20">
                    Rejeter Demande
                  </button>
                  <button 
                    disabled={isUpdating}
                    onClick={() => alert("Veuillez sélectionner un nouveau grade supérieur.")}
                    className="flex-1 md:flex-none px-12 py-5 bg-emerald-500 rounded-2xl text-[10px] font-black uppercase text-black shadow-2xl shadow-emerald-500/40 hover:scale-105 active:scale-95 transition-all flex items-center justify-center gap-3"
                  >
                    {isUpdating ? <RefreshCcw className="animate-spin" /> : <ShieldCheck size={18} />} 
                    Confirmer Encaissement
                  </button>
                </div>
            </div>

            {/* Filigrane Visuel SENTRY */}
            <div className="absolute -bottom-10 -right-10 text-[180px] font-black text-white/[0.02] pointer-events-none select-none italic tracking-tighter">
                SENTRY
            </div>
          </div>

          {/* KPI RÉSEAU AGENT */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-emerald-500/5 border border-emerald-500/20 p-8 rounded-[2.5rem] flex items-center gap-6 group hover:bg-emerald-500/10 transition-colors">
                <div className="p-4 bg-emerald-500 rounded-2xl text-black group-hover:scale-110 transition-transform"><DollarSign size={24}/></div>
                <div>
                    <p className="text-[9px] font-black text-emerald-500/60 uppercase tracking-widest">Recettes Journée</p>
                    <p className="text-3xl font-black italic tracking-tighter">85.000 <span className="text-xs not-italic text-slate-500">FCFA</span></p>
                </div>
            </div>
            <div className="bg-white/5 border border-white/10 p-8 rounded-[2.5rem] flex items-center gap-6 group">
                <div className="p-4 bg-white/10 rounded-2xl text-white group-hover:rotate-12 transition-transform"><Zap size={24}/></div>
                <div>
                    <p className="text-[9px] font-black text-slate-500 uppercase tracking-widest">Points Voyage Chine</p>
                    <p className="text-3xl font-black italic tracking-tighter text-emerald-500">1.455 <span className="text-xs not-italic text-slate-500">PTS</span></p>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgentCommandCenter;